import {gettext} from './../gettext-extract-util';

export const ASSET_DETAILS_STATE_NAME = 'asset_details';

class Status {
  constructor(key, description, cssClass) {
    this.key = key;
    this.description = description;
    this.cssClass = cssClass;
  }
}
const keyStatusMap = {
  no_alerts: new Status('no-alerts', '', 'no-alerts'),
  high: new Status('high', gettext('High'), 'high-alert'),
  medium: new Status('medium', gettext('Medium'), 'medium-alert'),
  low: new Status('low', gettext('Low'), 'low-alert'),
  due: new Status('due', gettext('Due'), 'high-alert'),
  upcoming: new Status('upcoming', gettext('Upcoming'), 'low-alert'),
  no_maintenance: new Status('no_maintenance', gettext('No Maintenance'), 'no-alerts'),
  loading: new Status('loading', gettext('loading...'), 'fa-spin')
};
export class StatusSummary {
  constructor(total, statusKey) {
    this.total = total;
    this.setStatus(statusKey);
  }

  setStatus(statusKey) {
    const {description, cssClass} = keyStatusMap[statusKey] || {};
    this.cssClass = cssClass;
    this.key = statusKey;
    this.label = description;
  }
}

export class AssetModel {
  constructor() {
    this.id = null;
    this.name = '';
    this.make = '';
    this.model = '';
    this.year = '';
    this.esn = '';
    this.profileImage = null;
    this.communicatedAt = null;
    this.createdAt = null;
    this.attrs = {};

    this.canPollData = false;
    this.showLocation = false;
    this.coords = [];
    this.device = {};
    this.faults = [];
    this.images = [];
    this.installation = {};
    this.maintenancePlans = [];
    this.series = [];
    this.defaultChartedseriesIds = [];
    // object will contain selected series with their data
    this.seriesData = {};
    this.locationSeries = null;
    // this.onei3.series = {};
    this.users = [];
    this.alerts = [];
    this.attributes = [];
    this.datapointDisplay = {};
    this.deviceCommands = null;
    this.alertStatus = new StatusSummary(undefined, 'loading');
    this.maintenanceStatus = new StatusSummary(undefined, 'loading');
    this.attributes = [];
    this.syncRunHours = null;
    this.hasCommandsToDisplay = false;
    this.hasSetAccumulatorCommand = false;
    //do need this
    //this.relationships = {};
  }
}

export class DateRange {
  constructor(startDate, endDate, option) {
    this.option = option;
    this.start = startDate;
    this.end = endDate;
  }
}

export class AssetDetailsState {
  constructor() {
    this.refreshing = false;
    this.selectedSeriesIds = [];
    this.loading = false;
    this.error = '';
    this.asset = new AssetModel();
    this.dataDateRange = undefined;
    this.seriesDataStatus = {chartLoading: false, valuesLoading: false};
    this.activeDataTap = 'chart';
  }
}

export const INITIAL_STATE = new AssetDetailsState();

//array of paths to keys need to be saved
export const AssetDetailWhiteListKeys = [];
